import { apiInstance, type ErrorResponse, postRequest } from '@/shared/api'

import type {
    CheckStatusResponse,
    CreateSbpSubscriptionResponse,
    GetPayMethodResponse,
} from './types'

import {
    CHANGE_STATUS_SUBSCRIPTION,
    CHECK_STATUS_SUBSCRIPTION,
    CREATE_SBP_SUBSCRIPTION,
    DELETE_PAY_METHOD,
    GET_PAY_METHODS,
} from './constants'

export function changeStatusSubscription(methodId: number, status: boolean) {
    return postRequest<unknown, ErrorResponse>(`${CHANGE_STATUS_SUBSCRIPTION}`, {
        payment_method_id: methodId,
        status,
    })
}

export function createSbpSubscription() {
    return postRequest<CreateSbpSubscriptionResponse, ErrorResponse>(
        `${CREATE_SBP_SUBSCRIPTION}`,
        {}
    )
}

export function deletePayMethod(methodId: number, sector: number) {
    return postRequest<unknown, ErrorResponse>(
        `${DELETE_PAY_METHOD}`,
        {
            payment_method_id: methodId,
            sector,
        },
        {
            method: 'post',
        }
    )
}

export function fetchStatusSubcription(sectorId: number, phone: string) {
    return apiInstance
        .get(`${CHECK_STATUS_SUBSCRIPTION}`, {
            searchParams: {
                phone,
                sector: sectorId,
            },
        })
        .json<CheckStatusResponse>()
}

export function getPayMethods() {
    return apiInstance.get(`${GET_PAY_METHODS}`).json<GetPayMethodResponse>()
}
